import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { SaveUserStateToServerHelper } from "../Helper";
import {
  nextDataEntryForm,
  nextExam,
  resetTempDataEntryData,
  setDataEntryData,
  setIsTypingStarted,
  setRemainingTime,
  setStartTime,
  setTempDataEntryData,
  updateDataEntryData,
} from "./../../actions/assessment";
import DataEntryForm from "./DataEntryForm";
import forms from "./data/data-entry.json";

export class DataEntryPracticeTest extends Component {
  state = {
    practice_answer:
      this.props.assessment.exams[this.props.assessment.exam_index]
        .practice_answer,
    submit_count: 0,
  };

  is_typing_started = () => {
    if (!this.props.is_typing_started) {
      this.props.setIsTypingStarted(true);
      this.props.setStartTime();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  render() {
    const dataEntryFields = forms[this.props.data_entry.data_index].map(
      (field, index) => {
        return (
          <tr key={index}>
            <td>{field.fieldname}</td>
            <td>{field.value}</td>
          </tr>
        );
      }
    );

    return (
      <div className="main container-fluid h-100">
        <div className="row justify-content-center align-items-center">
          <div className="col-12">
            <div className="container">
              <TransitionGroup className="card-container">
                <CSSTransition
                  key={this.props.question.id}
                  timeout={500}
                  classNames="fade"
                >
                  <div className="test">
                    <div className="question typing">
                      <span className="question-number">
                        Form {this.props.data_entry.form_index + 1}
                      </span>

                      {this.props.data_entry.form_index === 0 && (
                        <h4>
                          <span>
                            The timer will begin when you type your first
                            character in the first field. Remember, when you
                            complete typing the last string of a form, press the
                            Enter key to move to the next form. Your keystrokes
                            will not be captured for this practice test.{" "}
                          </span>
                        </h4>
                      )}

                      <div className="row">
                        <div className="col-6">
                          <h6 className="mb-3">Text to be typed :</h6>

                          <div className="card d-entry h-100">
                            <div
                              className="card-body"
                              style={{ userSelect: "none" }}
                            >
                              <table className="table table-bordered">
                                <tbody>{dataEntryFields}</tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <h6 className="mb-3">Type text here :</h6>

                          <div className="card d-entry h-100">
                            <div className="card-body">
                              <DataEntryForm
                                dataEntry={this.props.data_entry}
                                nextDataEntryForm={this.props.nextDataEntryForm}
                                is_typing_started={this.is_typing_started}
                                updateDataEntryData={
                                  this.props.updateDataEntryData
                                }
                                temp_data_entry_data={
                                  this.props.temp_data_entry_data
                                }
                                setTempDataEntryData={
                                  this.props.setTempDataEntryData
                                }
                                resetTempDataEntryData={
                                  this.props.resetTempDataEntryData
                                }
                                data_entry_data={this.props.data_entry_data}
                                setDataEntryData={this.props.setDataEntryData}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  question:
    state.assessment.exams[state.assessment.exam_index].questions[
      state.assessment.question_index
    ],
  is_typing_started: state.assessment.is_typing_started,
  data_entry: state.assessment.data_entry,
  data_entry_data: state.assessment.data_entry_data,
  temp_data_entry_data: state.assessment.temp_data_entry_data,
});

const mapDispatchToProps = (dispatch) => ({
  nextExam: () => dispatch(nextExam()),
  setRemainingTime: () => dispatch(setRemainingTime()),
  setIsTypingStarted: (value) => dispatch(setIsTypingStarted(value)),
  setStartTime: () => dispatch(setStartTime(Date.now())),
  nextDataEntryForm: (counter) => dispatch(nextDataEntryForm(counter)),
  updateDataEntryData: (counter, data) =>
    dispatch(updateDataEntryData(counter, data)),
  setTempDataEntryData: (tempData) => dispatch(setTempDataEntryData(tempData)),
  resetTempDataEntryData: () => dispatch(resetTempDataEntryData()),
  setDataEntryData: (dataEntryData, dataEntryCount) =>
    dispatch(setDataEntryData(dataEntryData, dataEntryCount)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataEntryPracticeTest);
